import type { SummaryMilestone } from '@/components/timeline-report/MilestoneSummarySelector';

/**
 * M1: Tra lại mốc sống theo id cho dải mốc tổng hợp.
 * - Mốc/hạng mục còn sống → làm mới name/date/sourceItemName từ dữ liệu live.
 * - Mốc đã xoá (hoặc cha đã xoá) → BỎ khỏi dải.
 * - Giữ nguyên color/pinned/offset/note/thứ tự.
 */
export function resolveSummaryMilestones(
  saved: SummaryMilestone[],
  live: {
    milestones: { id: string; item_id: string; name?: string | null; start_date?: string | null; end_date?: string | null }[];
    items: { id: string; name?: string | null; startDate?: string | null; endDate?: string | null; deleted_at?: string | null }[];
  }
): SummaryMilestone[] {
  if (!saved || saved.length === 0) return saved ?? [];

  const itemById = new Map<string, (typeof live.items)[number]>();
  for (const it of live.items || []) {
    if (it && it.id && !it.deleted_at) itemById.set(it.id, it);
  }

  const milestoneById = new Map<string, (typeof live.milestones)[number]>();
  for (const m of live.milestones || []) {
    if (m && m.id && itemById.has(m.item_id)) milestoneById.set(m.id, m);
  }

  const out: SummaryMilestone[] = [];
  for (const entry of saved) {
    const id = entry.id || '';

    if (entry.type === 'milestone') {
      // id dạng "milestone-start-<uuid>" / "milestone-end-<uuid>" (hoặc bare uuid cũ)
      const isEnd = id.startsWith('milestone-end-');
      const mid = id.replace(/^milestone-(start|end)-/, '');
      const m = milestoneById.get(mid);
      if (!m) continue; // mốc đã xoá → biến mất
      const parent = itemById.get(m.item_id);
      const date = (isEnd ? m.end_date : m.start_date) || m.start_date || m.end_date || entry.date;
      out.push({
        ...entry,
        name: m.name || entry.name,
        date: String(date).slice(0, 10),
        sourceItemName: parent?.name || entry.sourceItemName,
      });
      continue;
    }

    // type 'item': tra item sống theo sourceItemId
    const it = itemById.get(entry.sourceItemId);
    if (!it) continue;
    const isEnd = id.startsWith('item-end-');
    const date = (isEnd ? it.endDate : it.startDate) || it.startDate || it.endDate || entry.date;
    out.push({
      ...entry,
      name: it.name || entry.name,
      date: String(date).slice(0, 10),
      sourceItemName: it.name || entry.sourceItemName,
    });
  }

  return out;
}
